import { cn } from '@/utils/cn'
import { HTMLAttributes } from 'react'
import { useProductDetailPriceHistories } from '@/shared/ui/history-chart-component/use-product-detail-price-histories'
import { Skeleton } from '@/shared/ui/skeleton'

export const HistorySummary = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  const { duration, highestData, isPending, lastData } =
    useProductDetailPriceHistories()

  const formatCurrency = (value: number) => `${value.toLocaleString()}원`

  const diff = highestData?.price - lastData.price
  const diffPercent = (diff / highestData?.price) * 100

  const discount =
    diff !== 0
      ? `-${formatCurrency(highestData.priceHigh - lastData.price)}  (${!isPending && diffPercent.toFixed(1)}%)`
      : '0원'
  return (
    <div
      className={cn(
        'flex flex-col gap-4 rounded-lg border p-3 text-body-02-medium text-black sm:p-5',
        className,
      )}
      {...props}
    >
      <div className="flex justify-between text-gray-7">
        <span>{duration}간 최고가</span>
        <span>{formatCurrency(highestData.priceHigh)}</span>
      </div>
      <div className="flex justify-between">
        <span>할인된 금액</span>
        <div className="text-primary">
          <>
            {isPending && <Skeleton className="w-[120px]" />}
            {discount}
          </>
        </div>
      </div>
      <div className="flex justify-between font-bold">
        <span>현재가</span>
        <span>{formatCurrency(lastData.price)}</span>
      </div>
    </div>
  )
}
